<script lang="ts" setup>
import { computed } from 'vue';

import type { VRouterTab } from '@components/tabs/VRouterTabs/types';
import VCard from '@components/card/VCard/VCard.vue';
import VRouterTabs from '@components/tabs/VRouterTabs/VRouterTabs.vue';
import { useI18n } from '@modules/i18n/composables';
import { useMirrorsListNamespace } from '@modules/mirrors-list/composables';
import { TRANSLATION_GROUP_MIRRORS_CREATE } from '@modules/mirrors-list/submodules/create/constants';
import {
  MIRRORS_LIST_CREATE_FILE_JS_ROUTE_NAME,
  MIRRORS_LIST_CREATE_FILE_NO_JS_ROUTE_NAME,
} from '@modules/mirrors-list/submodules/create/submodules/file/constants';
import {
  MIRRORS_LIST_CREATE_JS_MANUALLY_ROUTE_NAME,
  MIRRORS_LIST_CREATE_NO_JS_MANUALLY_ROUTE_NAME,
} from '@modules/mirrors-list/submodules/create/submodules/manually/constants';

const { getTranslation } = useI18n();
const { isMirrorJsNamespace } = useMirrorsListNamespace();

const manuallyCreateRouteName = computed(() => (
  isMirrorJsNamespace.value ? MIRRORS_LIST_CREATE_JS_MANUALLY_ROUTE_NAME : MIRRORS_LIST_CREATE_NO_JS_MANUALLY_ROUTE_NAME
));

const fileCreateRouteName = computed(() => (
  isMirrorJsNamespace.value ? MIRRORS_LIST_CREATE_FILE_JS_ROUTE_NAME : MIRRORS_LIST_CREATE_FILE_NO_JS_ROUTE_NAME
));

const headerTitle = computed(() => (
  isMirrorJsNamespace.value
    ? getTranslation(TRANSLATION_GROUP_MIRRORS_CREATE, 'JS_ADD_HEADER').value
    : getTranslation(TRANSLATION_GROUP_MIRRORS_CREATE, 'NO_JS_ADD_HEADER').value
));

const manuallyTabLabel = computed(() => (
  isMirrorJsNamespace.value
    ? getTranslation(TRANSLATION_GROUP_MIRRORS_CREATE, 'JS_TAB_NAME_MANUAL').value
    : getTranslation(TRANSLATION_GROUP_MIRRORS_CREATE, 'NO_JS_TAB_NAME_MANUAL').value
));

const fileTabLabel = computed(() => (
  isMirrorJsNamespace.value
    ? getTranslation(TRANSLATION_GROUP_MIRRORS_CREATE, 'JS_FROM_FILE_TAB_NAME').value
    : getTranslation(TRANSLATION_GROUP_MIRRORS_CREATE, 'NO_JS_FROM_FILE_TAB_NAME').value
));

const tabs = computed<VRouterTab[]>(() => [
  {
    label: manuallyTabLabel.value,
    route: {
      name: manuallyCreateRouteName.value,
    },
  },
  {
    label: fileTabLabel.value,
    route: {
      name: fileCreateRouteName.value,
    },
  },
]);
</script>

<template>
  <VCard v-data-qa-auto-id="'MirrorsListCreatePage'"
    type="form"
    :title="headerTitle"
  >
    <VRouterTabs
      :items="tabs"
      replace
      class="mb-10"
    />
    <RouterView />
  </VCard>
</template>
